<template>
    <div>
        <!-- 主页 -->
        <keep-alive include="list_index">
            <component :is="myComponent" :key="myComponent"></component>
        </keep-alive>
    </div>
</template>
<script>
export default {
    components: {
        index: () => import("./index.vue"),
        add: () => import("./add.vue"),
        set: () => import("./set.vue"),
    },
    data() {
        return {};
    },
    mounted() {},
    computed: {
        myComponent() {
            return this.$store.state.chooseModule.value ? this.$store.state.chooseModule.value : "index";
        },
    },
    methods: {},
};
</script>
<style scoped></style>
